import React from 'react'
import classes from '../styles.module.scss'
import { useTranslation } from 'react-i18next'
import { ArrowLeftIcon } from '../../../assets/icons'
import { oblast } from '../../../consts/kato.conts'
import { useShared } from '../../../contexts/shared.context'
import { useNavigate } from 'react-router-dom'

const baseClass = 'header'

const Header = () => {
    const { t } = useTranslation()
    const { selectedInfoYear, setSelectedInfoYear, years } = useShared()
    const navigate = useNavigate()

    const handleGoBack = () => {
        const pathParts = window.location.pathname.split('/');
        pathParts.pop();
        const prevPath = pathParts.join('/') || '/';

        console.log(prevPath)
        if (prevPath === '/admin') {
            navigate(`/`)
        } else if (!isNaN(Number(prevPath.split('/').pop())) || prevPath.endsWith('/screening')) {
            navigate(`/admin`);
        } else {
            navigate(prevPath);
        }
    }
    return (
        <div className={classes[baseClass]}>
            <div className={classes[`${baseClass}__back`]} onClick={handleGoBack}>
                <ArrowLeftIcon />
                {t(`actions.back`)}
            </div>
            <div className={classes[`${baseClass}__oblast-name`]}>
                {oblast.nameRu}
            </div>
            <select
                name="year"
                id="year"
                value={selectedInfoYear}
                onChange={(e) => setSelectedInfoYear(Number(e.target.value))}
            >
                {years.map((year) => (
                    <option key={year} value={year}>
                        {year}
                    </option>
                ))}
            </select>
        </div>
    )
}

export default Header